export const USER_ROLES = {
  ADMIN: "admin",
  PROVIDER: "provider",
  PATIENT: "patient",
}